import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registrar Service Worker para PWA com auto-update
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (reg) => {
        console.log('SW registrado:', reg.scope);
        
        // Verificar atualizações a cada 60 segundos
        setInterval(() => {
          reg.update();
        }, 60000);
        
        // Quando encontrar nova versão, ativar imediatamente
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Nova versão disponível - recarregar página automaticamente
              console.log('Nova versão do app disponível, recarregando...');
              window.location.reload();
            }
          });
        });
      },
      (err) => console.log('SW falhou:', err)
    );
    
    // Recarregar quando o SW assumir controle
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    });
  });
}
